<template>
  <div class="header">
    <v-flex xs10 offset-xs1 class="vf fl aic">
      <AevitaeLogo primaryColor="#fff" secondaryColor="#fff" class="logo" />
      <h1>{{'header.income' | translate}}</h1>

      <v-spacer />

      <div class='mr-4'>
        <MainNavigationItem v-if="isAdmin"
          :isActive="isWorkStockActive"
          @click.native="navigateToWorkStock()"
          class='mr-3'
        >{{ 'work-stock-navigation-item' | translate }}</MainNavigationItem>

        <MainNavigationItem
          :isActive="isEmployeesActive"
          @click.native="navigateToEmployees()"
          class='mr-3'
        >{{ 'employees-navigation-item' | translate }}</MainNavigationItem>

        <MainNavigationItem
          :isActive="isReportsOfSicknessActive"
          @click.native="navigateToReportsOfSickness()"
        >{{ 'reports-of-sickness-navigation-item' | translate }}</MainNavigationItem>
      </div>

      <session-user />
    </v-flex>
  </div>
</template>

<script>
import AevitaeLogo from './AevitaeLogo.vue';

import { mapGetters } from 'vuex';

import MainNavigationItem from './MainNavigationItem.vue';
import SessionUser from './SessionUser.vue';
import AppNavigation from '@/views/constants/app-navigation';

import ReportsOfSickness from '@/views/constants/reports-of-sickness';
import Employees from '@/views/constants/employees';

export default {
  name: 'MainHeader',
  components: {
    AevitaeLogo,
    MainNavigationItem,
    SessionUser
  },
  computed: {
    ...mapGetters({
      activeView: 'appNavigationActiveView',
      selectedEmployer: 'selectedEmployer',
      reportsOfSicknessTabs: 'reportsOfSicknessTabs',
      employeesTabs: 'employeesTabs'
    }),

    isEmployeesActive () {
      return this.activeView === AppNavigation.Views.Employees;
    },
    isReportsOfSicknessActive () {
      return this.activeView === AppNavigation.Views.ReportsOfSickness;
    },
    isWorkStockActive () {
      return this.activeView === AppNavigation.Views.WorkStock;
    },

    isAdmin () {
      return this.$AuthService.isAdmin();
    }
  },
  methods: {
    navigateToReportsOfSickness () {
      this.$store.dispatch(AppNavigation.Actions.Navigate.DO, AppNavigation.Views.ReportsOfSickness)
        .then(this.$store.dispatch(ReportsOfSickness.Actions.Tabs.OPEN, this.reportsOfSicknessTabs[0]));
    },
    navigateToEmployees () {
      this.$store.dispatch(AppNavigation.Actions.Navigate.DO, AppNavigation.Views.Employees)
        .then(this.$store.dispatch(Employees.Actions.Tabs.OPEN, this.employeesTabs[0]));
    },
    navigateToWorkStock () {
      this.$store.dispatch(AppNavigation.Actions.Navigate.DO, AppNavigation.Views.WorkStock);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';

.header {
  display: block;
  background-color: $secondary-darken-2;
  height: 113px;
  position: relative;
  padding-bottom: 3px;

  h1 {
    color: #fff;

    margin-left: 20px;
    position: relative;
    top: -3px;

    &::before {
      content: "";
      position: absolute;
      background-color: #65b6cb;
      height: 25px;
      width: 1px;
      left: -22px;
      top: 13px;
      display: block;
    }
  }
}

.logo {
  width: 135px;
  height: 50px;
  position: relative;
  top: -12px;
  margin-right: 20px;
}

.portrait {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;

  box-sizing: context-box;
  background-color: $secondary;

  padding: 1px;
  box-shadow: 0 0 1px 0 white inset, 0 0 1px 0 $secondary;

  img {
    margin: 0 auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 110%;
    left: -4%;
    position: relative;
    top: -3%;
  }
}
</style>
